import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-694f1734")

_pushScopeId("data-v-694f1734")
const _hoisted_1 = { class: "form-project" }
const _hoisted_2 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("dig-input-text", {
      id: "name",
      value: $setup.projectForm.name,
      onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.projectForm.name = $event.target.value)),
      required: ""
    }, _toDisplayString($setup.t('Project.name')), 41, ["value"]),
    _createVNode("dig-input-text", {
      id: "address",
      value: $setup.projectForm.address,
      onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.projectForm.address = $event.target.value))
    }, _toDisplayString($setup.t('Project.address')), 41, ["value"]),
    _createVNode("dig-input-text", {
      id: "cp",
      value: $setup.projectForm.cp,
      onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.projectForm.cp = $event.target.value))
    }, _toDisplayString($setup.t('Project.cp')), 41, ["value"]),
    _createVNode("dig-input-text", {
      id: "city",
      value: $setup.projectForm.city,
      onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.projectForm.city = $event.target.value))
    }, _toDisplayString($setup.t('Project.city')), 41, ["value"]),
    _createVNode("dig-input-text", {
      id: "siret",
      value: $setup.projectForm.siret,
      onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.projectForm.siret = $event.target.value))
    }, _toDisplayString($setup.t('Project.siret')), 41, ["value"]),
    _createVNode("dig-input-text", {
      id: "email",
      value: $setup.projectForm.email,
      onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.projectForm.email = $event.target.value)),
      type: "email"
    }, _toDisplayString($setup.t('Project.email')), 41, ["value"]),
    _createVNode("dig-input-phone", {
      id: "phone",
      value: $setup.projectForm.phone,
      onInput: _cache[7] || (_cache[7] = ($event: any) => ($setup.projectForm.phone = $event.target.value))
    }, _toDisplayString($setup.t('Project.phone')), 41, ["value"]),
    _createVNode("label", null, _toDisplayString($setup.t('Project.color')), 1),
    _withDirectives(_createVNode("input", {
      type: "color",
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.projectForm.color = $event))
    }, null, 512), [
      [_vModelText, $setup.projectForm.color]
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.cancel())),
        disabled: $props.loading,
        class: "cancel"
      }, _toDisplayString($setup.t('cancel')), 9, ["disabled"]),
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.validate())),
        disabled: $props.loading
      }, _toDisplayString($setup.t('validate')), 9, ["disabled"])
    ])
  ]))
})